// extracted by mini-css-extract-plugin
export var dropdownIcon = "_kn-6";
export var imgContainer = "_kn-3";
export var menuIcon = "_kn-5";
export var pillWrapper = "_kn-2";
export var pillsContainer = "_kn-1";
export var subscriptionCard = "_kn-0";
export var subscriptionLogo = "_kn-4";